__turbopack_context__.v({
  "callButton": "_43ZLEW_callButton",
  "copiedLive": "_43ZLEW_copiedLive",
  "phoneNumberButton": "_43ZLEW_phoneNumberButton",
  "wrapper": "_43ZLEW_wrapper",
});
